import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const gitpod = defineConnector({
  identifier: "gitpod",
  name: "Gitpod",
  tagLine: "Cloud development environments",
  logo,
  protocol: "http",
  tags: ["engineering"],
  defaultUrlPattern: () => "https://api\\.gitpod\\.io/.*",
  auth: (app) => bearerAuth(app.secret.personalAccessToken),
  steps: [
    {
      title: "Create a Gitpod personal access token",
      items: [
        {
          kind: "markdown",
          content:
            "Create a personal access token in Gitpod and use it as a bearer token for the Gitpod API.",
        },
      ],
    },
    {
      title: "Enter your personal access token",
      items: [
        {
          kind: "input",
          label: "Personal access token",
          required: true,
          target: { kind: "secrets", field: "personalAccessToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => ({
      url: "https://api.gitpod.io/gitpod.v1.OrganizationService/ListOrganizations",
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: "{}",
      expectedStatus: [200, 403],
    }),
  },
});
